
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.08 21.917L5.288 7.333l9.375 9.375L.08 21.917zm3.438-3.438l7.343-2.604-4.74-4.74-2.603 7.344zm9.635-6.406l-1.094-1.094 5.834-5.833a2.733 2.733 0 012.005-.833c.781 0 1.45.277 2.005.833l.625.625-1.094 1.094-.625-.625a1.236 1.236 0 00-.911-.365c-.365 0-.669.122-.912.365l-5.833 5.833zM8.986 7.906L7.893 6.813l.625-.625c.243-.244.364-.539.364-.886s-.121-.642-.364-.885L7.84 3.74l1.094-1.094.677.677c.556.555.834 1.215.834 1.98 0 .763-.278 1.423-.834 1.978l-.625.625zM11.07 9.99L9.976 8.896l3.75-3.75c.243-.243.364-.547.364-.912 0-.364-.121-.668-.364-.911l-1.667-1.667L13.153.563l1.667 1.666c.555.556.833 1.224.833 2.005 0 .782-.278 1.45-.833 2.006l-3.75 3.75zm4.166 4.166l-1.093-1.094 1.666-1.666a2.734 2.734 0 012.005-.834c.782 0 1.45.278 2.006.834l1.666 1.666-1.093 1.094-1.667-1.666a1.236 1.236 0 00-.912-.365c-.364 0-.668.121-.911.365l-1.667 1.666z","fill":"#8FB0C4"}})])
          )
        }
      }
    